var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-new-card",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"plus-button"},[_vm._v("+")]),_c('span',[_vm._v("Add New")])])
}
var staticRenderFns = []

export { render, staticRenderFns }